export default __webpack_public_path__ + "static/media/tn.b031c696.svg";